<div class="summary-container">
    <div class="summary-header">{{header}}</div>
    <div class="summary-value">{{value}}</div>
</div>